import config from "../config";

const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID;
const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
const apiScope = process.env.REACT_APP_MICROSOFT_API_SCOPE;
const authority = tenantId ? `https://login.microsoftonline.com/${tenantId}` : undefined;

export const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri: config.authRedirectUri,
        postLogoutRedirectUri: config.authRedirectUri,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: apiScope ? [apiScope] : []
};

export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
};

export const protectedResources = {
    rentasApi: {
        endpoint: config.baseResource,
        scopes: {
            fullAccess: loginRequest.scopes,
        },
    },
};
